module.exports = __webpack_public_path__ + "img/20190626085850.fdc8c11b.png";